(() => {
  if (window.HoKProductCountdownLoaded) return;
  window.HoKProductCountdownLoaded = true;

  /**
   * Product Countdown Timer - Three States: Day Left, Day Start, Close
   * Updates product countdown badge in real-time with proper state handling
   */
  class ProductCountdown {
    constructor() {
      this.badges = document.querySelectorAll('.collection-countdown-badge');
      this.countdownInterval = null;
      this.init();
    }

  init() {
    if (this.badges.length === 0) return;
    
    this.startCountdown();
  }

  startCountdown() {
    // Update countdown every minute
    this.countdownInterval = setInterval(() => {
      this.badges.forEach(badge => {
        this.updateBadge(badge);
      });
    }, 60000); // Update every minute

    // Initial update
    this.badges.forEach(badge => {
      this.updateBadge(badge);
    });
  }

  updateBadge(badge) {
    // Get dates from data attributes (these are already formatted by Liquid)
    const startDateStr = badge.dataset.startDate; // Format: YYYY-MM-DD
    const endDateStr = badge.dataset.endDate;     // Format: YYYY-MM-DD
    
    // Get current date in YYYY-MM-DD format (same as Liquid 'now' | date: '%Y-%m-%d')
    const now = new Date();
    const currentDateStr = now.getFullYear() + '-' + 
                          String(now.getMonth() + 1).padStart(2, '0') + '-' + 
                          String(now.getDate()).padStart(2, '0');
    
    let daysRemaining = 0;
    let daysUntilStart = 0;
    let eventStatus = 'active';
    
    // Use EXACTLY the same logic as Liquid template
    if (currentDateStr < startDateStr) {
      // Event hasn't started yet (same as Liquid: current_date < start_date_str)
      eventStatus = 'upcoming';
      
      // Calculate days until start using same method as Liquid
      const startDate = new Date(startDateStr + 'T00:00:00');
      const currentDate = new Date(currentDateStr + 'T00:00:00');
      const startTimestamp = startDate.getTime();
      const currentTimestamp = currentDate.getTime();
      daysUntilStart = Math.ceil((startTimestamp - currentTimestamp) / (1000 * 60 * 60 * 24));
      
    } else if (currentDateStr >= startDateStr && currentDateStr <= endDateStr) {
      // Event is active (same as Liquid: current_date >= start_date_str and current_date <= end_date_str)
      eventStatus = 'active';
      
      // Calculate days remaining using same method as Liquid
      const endDate = new Date(endDateStr + 'T23:59:59');
      const currentDate = new Date(currentDateStr + 'T00:00:00');
      const endTimestamp = endDate.getTime();
      const currentTimestamp = currentDate.getTime();
      
      daysRemaining = Math.floor((endTimestamp - currentTimestamp) / (1000 * 60 * 60 * 24));
      
      // If it's the same day, show 0 days left
      if (currentDateStr === endDateStr) {
        daysRemaining = 0;
      }
      
    } else {
      // Event has ended (same as Liquid: else)
      eventStatus = 'ended';
      daysRemaining = 0;
    }

    // Update badge content based on status
    this.updateBadgeContent(badge, eventStatus, daysRemaining, daysUntilStart);
    
    // Update data attributes
    badge.dataset.eventStatus = eventStatus;
    badge.dataset.daysRemaining = daysRemaining;
    badge.dataset.daysUntilStart = daysUntilStart;
  }

  updateBadgeContent(badge, eventStatus, daysRemaining, daysUntilStart) {
    // Update CSS classes
    badge.className = `collection-countdown-badge collection-countdown--${eventStatus}`;
    
    if (eventStatus === 'ended') {
      // Show Close button when event ended
      if (!badge.querySelector('.countdown-close-btn')) {
        badge.innerHTML = `
          <button class="countdown-close-btn" onclick="this.closest('.collection-countdown-badge').style.display='none'">
            Close
          </button>
        `;
      }
    } else if (eventStatus === 'upcoming') {
      // Show Days Until Start when event hasn't started
      if (!badge.querySelector('.countdown-days') || !badge.querySelector('.countdown-label') || badge.querySelector('.countdown-label').textContent !== 'Days Start') {
        badge.innerHTML = `
          <span class="countdown-days">${daysUntilStart}</span>
          <span class="countdown-label">Days Start</span>
        `;
      } else {
        // Update existing countdown elements
        const daysElement = badge.querySelector('.countdown-days');
        if (daysElement) {
          daysElement.textContent = daysUntilStart;
        }
      }
    } else {
      // Show Days Left when event is active
      if (!badge.querySelector('.countdown-days') || !badge.querySelector('.countdown-label') || badge.querySelector('.countdown-label').textContent !== 'Days Left') {
        badge.innerHTML = `
          <span class="countdown-days">${daysRemaining}</span>
          <span class="countdown-label">Days Left</span>
        `;
      } else {
        // Update existing countdown elements
        const daysElement = badge.querySelector('.countdown-days');
        if (daysElement) {
          daysElement.textContent = daysRemaining;
        }
      }
    }
  }

  destroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }
  }

  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new ProductCountdown();
  });

  // Initialize for dynamic content (Shopify sections)
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.collection-countdown-badge')) {
      new ProductCountdown();
    }
  });

  // Initialize for product recommendations (related products)
  document.addEventListener('shopify:recommendations:loaded', (event) => {
    if (event.target.querySelector('.collection-countdown-badge')) {
      new ProductCountdown();
    }
  });

  // Initialize for any dynamic content changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.querySelector('.collection-countdown-badge') || node.classList.contains('collection-countdown-badge')) {
              new ProductCountdown();
            }
          }
        });
      }
    });
  });

  // Start observing
  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  // Cleanup when section is unloaded
  document.addEventListener('shopify:section:unload', (event) => {
    const countdown = event.target.querySelector('.collection-countdown-badge');
    if (countdown && countdown.instance) {
      countdown.instance.destroy();
    }
  });

  window.ProductCountdown = ProductCountdown;
})();
